import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'createdDate';
export const apiKey = 'CreatedDateTime';
export const type = TYPE_DATE_COMPARISON;

export const createdDate = {
  id,
  apiKey,
  type,
};
